module.exports = __webpack_public_path__ + "fonts/cfceaf4.woff2";